import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { THREE_LETTER_EUROPE_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_EUROPE_COUNTRY_CODES";
import { getSettingBrandAdditionalSupportedGeographies } from "@faire/retailer/settings/getSettingBrandAdditionalSupportedGeographies";
import { getSettingSupportedCountries } from "@faire/retailer/settings/getSettingSupportedCountries";
var getAutoAcceptedCountries = function() {
    var autoAcceptedCountries = [];
    var brandAdditionalSupportedGeographies = getSettingBrandAdditionalSupportedGeographies();
    brandAdditionalSupportedGeographies.forEach(function(geo) {
        if (geo.country) {
            autoAcceptedCountries.push(geo.country);
        }
        if (geo.country_group && geo.country_group === "EUROPE") {
            autoAcceptedCountries = autoAcceptedCountries.concat(Object.values(THREE_LETTER_EUROPE_COUNTRY_CODES));
        }
    });
    var union = require("arr-union");
    return union(autoAcceptedCountries, getSettingSupportedCountries()).sort();
};
export var getBrandSignupAutoAcceptedThreeLetterCodes = function() {
    return getAutoAcceptedCountries();
};
export var getBrandSignupAutoAcceptedCountriesOptions = function(strictLocalize) {
    return _to_consumable_array(getBrandSignupAutoAcceptedThreeLetterCodes().map(function(code) {
        return {
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            label: ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[code],
            value: code
        };
    }).sort(function(a, b) {
        if (a.label > b.label) {
            return 1;
        } else if (a.label < b.label) {
            return -1;
        } else {
            return 0;
        }
    })).concat([
        {
            label: strictLocalize({
                id: "GZbpBJ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Other"
                    }
                ]
            }),
            value: "Other"
        }
    ]);
};
